var map = {
	"@modules/access-role/access-role.module": [
		"./src/app/modules/access-role/access-role.module.ts",
		"common",
		"modules-access-role-access-role-module"
	],
	"@modules/auth/login/login.module": [
		"./src/app/modules/auth/login/login.module.ts",
		"modules-auth-login-login-module"
	],
	"@modules/company/company.module": [
		"./src/app/modules/company/company.module.ts",
		"modules-company-company-module"
	],
	"@modules/dashboard/dashboard.module": [
		"./src/app/modules/dashboard/dashboard.module.ts",
		"modules-dashboard-dashboard-module"
	],
	"@modules/designation/designation.module": [
		"./src/app/modules/designation/designation.module.ts",
		"common",
		"modules-designation-designation-module"
	],
	"@modules/error/error.module": [
		"./src/app/modules/error/error.module.ts",
		"modules-error-error-module"
	],
	"@modules/file-system/file-system.module": [
		"./src/app/modules/file-system/file-system.module.ts",
		"default~modules-file-system-file-system-module~modules-share-share-module~modules-simple-sign-form-s~ffa462a6",
		"default~modules-file-system-file-system-module~modules-share-share-module",
		"default~modules-file-system-file-system-module~modules-simple-sign-form-simple-sign-form-module",
		"common",
		"modules-file-system-file-system-module"
	],
	"@modules/mail/mail.module": [
		"./src/app/modules/mail/mail.module.ts",
		"modules-mail-mail-module"
	],
	"@modules/profile/profile.module": [
		"./src/app/modules/profile/profile.module.ts",
		"modules-profile-profile-module"
	],
	"@modules/rbac/rbac.module": [
		"./src/app/modules/rbac/rbac.module.ts",
		"modules-rbac-rbac-module"
	],
	"@modules/share/share.module": [
		"./src/app/modules/share/share.module.ts",
		"default~modules-file-system-file-system-module~modules-share-share-module~modules-simple-sign-form-s~ffa462a6",
		"default~modules-file-system-file-system-module~modules-share-share-module",
		"modules-share-share-module"
	],
	"@modules/simple-sign-form/simple-sign-form.module": [
		"./src/app/modules/simple-sign-form/simple-sign-form.module.ts",
		"default~modules-file-system-file-system-module~modules-share-share-module~modules-simple-sign-form-s~ffa462a6",
		"default~modules-file-system-file-system-module~modules-simple-sign-form-simple-sign-form-module",
		"modules-simple-sign-form-simple-sign-form-module"
	],
	"@modules/staff/staff.module": [
		"./src/app/modules/staff/staff.module.ts",
		"default~modules-file-system-file-system-module~modules-share-share-module~modules-simple-sign-form-s~ffa462a6",
		"common",
		"modules-staff-staff-module"
	],
	"@modules/user/user.module": [
		"./src/app/modules/user/user.module.ts",
		"common",
		"modules-user-user-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;